import {useSettingsQuery} from '../providers/ApiInterface'

export const usePlantConfig = (upmPlantId?: string, hasPermissions?: boolean) => {
  return useSettingsQuery('plantConfig', [upmPlantId], {
    gcTime: 0,
    retry: false,
    staleTime: 0,
    enabled: !!upmPlantId && hasPermissions
  })
}

export const QueryKey = 'upmPlantConfig'
